import { cn } from "@omni/utils/styles";

import { Anchor } from "@/components/General/Anchor/anchor.component";
import { useCategoryContext } from "@/components/Navigation/FlyoutMenu/components/category/context/category.context";

type Props = {
    className?: string;
};

export const Title = ({ className }: Props) => {
    const { index, category } = useCategoryContext();

    if (index === 0 || !category.subCategories?.length) return null;

    return (
        <Anchor
            color={"link"}
            href={category.url}
            className={cn("tw:text-xl! tw:text-left", className)}
        >
            {category.title}
        </Anchor>
    );
};
